import { useContext } from 'react';
import { HorizonTypesContext } from '@shapeable/ui';
import { HorizonType } from '@shapeable/copper-connect-types';
export const useHorizonTypes = () => useContext<HorizonType[]>(HorizonTypesContext);